import { useTranslation } from "react-i18next";

import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import { ButtonBase, Typography } from "@mui/material";

interface Props {
  onClick: () => void;
}

export function ErrorFieldLink({ onClick }: Props) {
  const { t } = useTranslation();

  return (
    <ButtonBase onClick={onClick} sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      <ArrowUpwardRoundedIcon sx={{ fontSize: 18 }} aria-hidden="true" />
      <Typography variant="caption" color="black">
        {t("common.toFirstError")}
      </Typography>
    </ButtonBase>
  );
}
